<script setup lang="ts">
import LoadingPage from './pages/LoadingPage/LoadingPage.vue';
import { initGoogleAnalyticsSDK } from '@/tools/ga4Manager';
import { initAdManager } from '@/tools/adManager';
import { initJSBridge, isJSBridgeLoading } from './tools/jsBridgeManager';
import { initCloudObservation } from '@/tools/cloudObservation';

// 初始化 RUM
initCloudObservation();

// 初始化 GA4
initGoogleAnalyticsSDK();

// 初始化 Ad Manager
initAdManager();

// 初始化 JSBridge 检查
initJSBridge();
</script>

<template>
    <template v-if="isJSBridgeLoading">
        <LoadingPage />
    </template>
    <template v-else>
        <router-view v-slot="{ Component, route }">
            <keep-alive>
                <component
                    :is="Component"
                    v-if="route.meta?.keepAlive"
                    :key="route.fullPath"
                />
            </keep-alive>
            <component
                :is="Component"
                v-if="!route.meta?.keepAlive"
                :key="route.fullPath"
            />
        </router-view>
    </template>
</template>

<style lang="scss">
@use '@/styles/reset.scss';

#app {
    // 限制页面最大宽度, 保证在 PC 端打开不会过于浮夸
    max-width: 10rem;
    margin: 0 auto;
    box-shadow: 0 0 40px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    min-height: 100vh;

    @media (prefers-color-scheme: dark) {
        box-shadow: 0 0 40px rgba(255, 255, 255, 0.15);
    }
}

:root {
    min-height: 100vh;
    color: var(--page-text);
    background-color: var(--page-background);
    font-family: 'OPPO Sans 4.0', 'OPPO Sans', sans-serif;

    & {
        --page-background: rgba(255, 255, 255, 1);
        --page-text: rgba(0, 0, 0, 0.9);

        @media (prefers-color-scheme: dark) {
            --page-background: rgba(0, 0, 0, 1);
            --page-text: rgba(255, 255, 255, 0.9);
        }
    }
}
</style>
